<template>
  <v-app dark>
    <div class="table">
      <v-text-field class="mb-4"
          v-model="search"
          prepend-inner-icon="mdi-magnify"
          :label="'Buscar'"
          background-color="white"
          color="black"
          clearable
          outlined
          dense
          single-line
          hide-details/>
      <v-data-table :headers="headers"
          :items="audiobook"
          :search="search"
          :sort-by="'id'"
          :loading="loading"
          :locale="'es-ES'"
          dense>
        <template v-slot:item.actions="{item}">
          <v-tooltip v-if="item.audioSrc" color="primary" bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn v-bind="attrs"
                  v-on="on"
                  class="my-2 ml-1"
                  :small="!$vuetify.breakpoint.xs"
                  icon
                  @click.stop="openAudio(item)">
                <v-icon :small="!$vuetify.breakpoint.xs">mdi-volume-high</v-icon>
              </v-btn>
            </template>
            <span>Escuchar</span>
          </v-tooltip>
          <v-tooltip v-if="item.youtubeId" color="primary" bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn v-bind="attrs"
                  v-on="on"
                  class="my-2 ml-1"
                  :small="!$vuetify.breakpoint.xs"
                  icon
                  @click.stop="openVideo(item)">
                <v-icon :small="!$vuetify.breakpoint.xs">mdi-youtube</v-icon>
              </v-btn>
            </template>
            <span>YouTube</span>
          </v-tooltip>
          <v-tooltip v-if="item.audioSrc" color="primary" bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn v-bind="attrs"
                  v-on="on"
                  class="my-2 ml-1"
                  :small="!$vuetify.breakpoint.xs"
                  icon
                  @click.stop="download(item)">
                <v-icon :small="!$vuetify.breakpoint.xs">mdi-download</v-icon>
              </v-btn>
            </template>
            <span>Descargar</span>
          </v-tooltip>
        </template>
      </v-data-table>
    </div>
    <div v-if="admin" class="wordpress-user text-center pt-6">
      <v-btn color="primary" @click="getMetrics">Descargar datos de uso</v-btn>
      <span class="ma-4 d-inline-block">
        Convertir JSON a CSV <a href="https://data.page/json/csv" target="_blank" title="Página externa">aquí</a>
      </span>
    </div>
    <v-dialog v-model="audio.show" content-class="audio-player" @input="closeAudio(audio)">
      <v-card light>
        <v-card-title>{{audio.title}}</v-card-title>
        <audio ref="audio" :src="audio.src" controls autoplay></audio>
      </v-card>
    </v-dialog>
    <v-dialog v-model="downloading" persistent width="300">
      <v-card color="primary" light>
        <v-card-text class="text-center">
          <div class="pt-2 pb-1">Descargando fichero de audio</div>
          <v-progress-linear indeterminate color="black" class="mb-0"></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-app>
</template>

<script>
import axios from 'axios'

export default {
  name: 'App',
  props: {
    admin: {type: Boolean, default: false}
  },
  data() {
    return {
      basePath: location.origin === 'https://www.cambiosprofundos.com'
        ? `${location.origin}` : 'http://plugins.cambiosprofundos.com',
      search: null,
      headers: [
        {width: 80, text: 'Día', value: 'id'},
        {text: 'Título', value: 'title'},
        {width: 84, text: '', value: 'actions'}
      ],
      audio: {
        show: false,
        id: null,
        title: null,
        src: null
      },
      loading: true,
      downloading: false,
      audiobook: []
    }
  },
  computed: {
    serverPath: function () {
      return `${this.basePath}/wp-content/plugins/cp-audiobook/server`
    }
  },
  created() {
    axios.get(`${this.serverPath}/audiobook.php`)
      .then(response => {
        this.audiobook = response.data.audiobook
        this.loading = false
      })
  },
  methods: {
    openAudio(item) {
      this.audio.show = true
      this.audio.id = item.id
      this.audio.title = item.title
      this.audio.src = item.audioSrc
      this.registerMetric({action: 'Open audio', item})
    },
    closeAudio(item) {
      this.audio.id = null
      this.audio.src = null
      this.$refs.audio.pause()
      this.$refs.audio.currentTime = 0
      this.registerMetric({action: 'Close audio', item})
    },
    download(item) {
      this.downloading = true
      axios.post(`${this.serverPath}/download-audiobook.php`, {item}, {
        responseType: 'blob'
      })
        .then((response) => {
          const link = document.createElement('a');
          link.href = window.URL.createObjectURL(new Blob([response.data]));
          link.setAttribute('download', `${item.id} - ${item.title}.mp3`);
          link.click();
          this.downloading = false
          this.registerMetric({action: 'Download audio', item})
        })
    },
    registerMetric({action, item}) {
      axios.post(`${this.serverPath}/audiobook-metrics.php`, {action, item})
        .then((response) => {
          if (response.status === 200) console.log('Metric registered', response.data);
        })
    },
    getMetrics() {
      axios.get(`${this.serverPath}/audiobook-metrics.php`)
        .then((response) => {
          const link = document.createElement('a');
          link.href = window.URL.createObjectURL(new Blob([JSON.stringify(response.data)], {type: 'application/json'}));
          link.setAttribute('download', `${new Date().getTime()}-audiobook-metrics.json`);
          link.click();
        })
    }
  }
}
</script>

<style lang="scss" scoped>
$primary: #e9ca7c;
$primary-dark: #9a751b;
$secondary: #f5e7c5;

@font-face {
  font-family: 'Gotham Book';
  src: url('assets/Gotham-Book.otf');
}

@font-face {
  font-family: 'Gotham Light';
  src: url('assets/Gotham-Light.otf');
}

.v-application {
  background-color: transparent !important;
  font-family: 'Gotham Book', serif;
  font-size: 0.9em;
  line-height: 1.25em;
  padding: 0;

  ::v-deep .theme--dark {
    color: black;

    &.v-list {
      padding: 0;
    }

    &.v-list-item {
      background-color: $secondary;
      color: black !important;
      font-family: 'Gotham Light', serif;

      &.v-list-item--active {
        &:not(.v-list-item--disabled) {
          background-color: $primary;
          color: black !important;

          &:before {
            content: none;
          }
        }
      }
    }
  }

  ::v-deep .v-tooltip__content {
    color: black;
  }

  ::v-deep .v-application--wrap {
    min-height: unset;
  }

  .table {
    ::v-deep button {
      border: none;
      padding: 0;

      &:hover,
      &:focus {
        background-color: inherit;
        outline: none;
      }
    }

    ::v-deep .v-input {
      .v-input__control {
        .v-input__slot {
          color: $primary-dark;

          label {
            font-weight: bold;
          }

          label,
          input,
          fieldset,
          i {
            color: $primary-dark !important;
          }

          input {
            border: none;
          }
        }
      }
    }

    ::v-deep .v-data-table {
      > .v-data-table__wrapper {
        background-color: $secondary;
        border: 1px solid white;

        > table {
          font-size: 1em;
          margin: 0;

          > thead {
            background-color: $primary;
            opacity: 1.8;

            > tr {
              > th {
                border: none;
                color: black;
                font-family: 'Gotham Light', serif;
                font-size: 1.05em;
                border-bottom: 1px solid white;
                padding: 10px 16px 11px;

                &.column {
                  padding: 0;

                  .v-progress-linear {
                    color: black;

                    .v-progress-linear__background {
                      background-color: black !important;
                      border-color: black !important;
                    }
                  }
                }

                span {
                  top: 2px;
                  position: relative;
                }

                .v-icon {
                  color: $primary-dark;
                }
              }
            }
          }

          > tbody {
            > tr {
              background-color: rgba(233, 202, 124, 0.1);

              > td {
                background-color: rgba(233, 202, 124, 0.1);
                border: none;
                font-family: 'Gotham Light', serif;
                font-size: .9em;
                height: 36px !important;
                line-height: 16px;
                vertical-align: middle;
                -webkit-touch-callout: none; /* iOS Safari */
                -webkit-user-select: none; /* Safari */
                -moz-user-select: none; /* Old versions of Firefox */
                -ms-user-select: none; /* Internet Explorer/Edge */
                user-select: none; /* Non-prefixed version, currently supported by Chrome, Edge, Opera and Firefox */

                .v-icon {
                  color: black !important;
                }

                &:last-child {
                  padding: 0 8px;
                }
              }

              &:not(.v-data-table__empty-wrapper) {
                &:hover {
                  > td {
                    background-color: $primary-dark;
                    color: white;
                    font-weight: bold;

                    .v-icon {
                      color: white !important;
                    }
                  }
                }
              }

              &.v-data-table__empty-wrapper {
                > td {
                  color: black;
                  height: 447px !important;
                }
              }
            }
          }
        }
      }

      > .v-data-footer {
        background-color: $primary;
        border-right: 1px solid white;
        border-bottom: 1px solid white;
        border-left: 1px solid white;

        .v-data-footer__select {
          .v-select {
            margin: 8px 0 8px 20px;

            .v-select__selections {
              color: $primary-dark !important;
            }
          }
        }

        .v-btn {
          &.v-btn--disabled {
            .v-icon {
              color: $secondary !important;
            }
          }
        }

        .v-btn {
          &:not(.v-btn--disabled) {
            .v-icon {
              color: $primary-dark !important;
            }
          }
        }
      }
    }
  }

  .wordpress-user {
    color: $primary-dark;

    .v-btn {
      color: black;
    }
  }

  ::v-deep .v-dialog {
    &.audio-player {
      width: auto;

      .v-card {
        max-width: 500px;
        padding-bottom: 1.25em;
        position: relative;
        text-align: center;

        .v-card__title {
          word-break: break-word;
        }
      }
    }
  }

  @media (max-width: 600px) {
    .table {
      ::v-deep .v-data-table {
        > .v-data-table__wrapper {
          > table {
            > thead {
              > tr {
                > th {
                  font-family: 'Gotham Light', serif;
                  border-bottom: 1px solid white;
                  padding: 0 16px;

                  .v-select__slot {
                    label,
                    i {
                      color: $primary-dark !important;
                    }

                    span {
                      top: 0;
                    }

                    .v-chip {
                      background: $secondary;
                      margin: 8px 0 0 0;
                    }
                  }
                }
              }
            }

            > tbody {
              > tr {
                &.v-data-table__mobile-table-row {
                  display: grid;
                  position: relative;

                  > td {
                    &.v-data-table__mobile-row {
                      border: none;
                      min-height: 30px;
                      padding-top: 10px;
                      line-height: 16px;

                      .v-data-table__mobile-row__header {
                        display: none;
                      }

                      .v-data-table__mobile-row__cell {
                        text-align: left;
                        width: 100%;
                      }

                      &:first-child {
                        display: inline-block;
                        position: absolute;
                        font-size: 18px;
                        top: 4px;
                      }

                      &:nth-child(2) {
                        padding-left: 60px;
                      }

                      &:last-child {
                        padding-bottom: 10px;

                        &.v-data-table__mobile-row {
                          border-bottom: 1px solid white;

                          .v-data-table__mobile-row__cell {
                            text-align: center;
                            width: 100%;
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }

        .v-data-footer {
          .v-data-footer__select,
          .v-data-footer__pagination {
            margin: 0 10px;
          }
        }
      }
    }
  }
}
</style>
